import { callApiWithAuthorization } from "../CallApi";

export async function getPlanningConfiguration(organizationId) {
    const request = await callApiWithAuthorization(`/api/v0/organization/${organizationId}/getPlanningConfiguration`);
    const response = await request.json();
    return response;
}

export async function updatePlanningConfiguration(planningId, data, type) {
    const request = await callApiWithAuthorization(`/api/v0/updatePlanningConfiguration/${planningId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ type, data }),
    });
    const response = await request.json();
    return response;
}

export async function getPlanningItems(projectId) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/getPlanningItems`);
    const response = await request.json();
    return response;
}